import React from 'react';

import PropTypes from 'prop-types';

function BaseIcon(props) {
    const {
        children,
        className,
        color,
        size = '1em',
        style,
        width,
        height,
        ...otherProps
    } = props;

    return (
        <svg
            {...otherProps}
            className={className}
            fill="currentColor"
            height={height || size}
            preserveAspectRatio="xMidYMid meet"
            style={{
                verticalAlign: 'middle',
                color: color,
                ...style,
            }}
            width={width || size}
        >
            {children}
        </svg>
    );
}

BaseIcon.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    color: PropTypes.string,
    height: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]),
    size: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]),
    style: PropTypes.object,
    width: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]),
};

export default BaseIcon;
